import React from "react";
import "./About.css";
import ayush from "../assets/ayush.jpg";
import { Link } from "react-router-dom";
import Footer from "./Footer";

const About = () => {
  return (
    <>
    <div className="about-container">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="about-hero-content">
          <h1>About New Pitman's Institute India</h1>
          <p>Excellence in Shorthand & Typing Education Since 1994</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="about-main">
        <div className="about-section">
          <h2>Our Story</h2>
          <p>
            New Pitman's Institute India, established in 1994 by the visionary Mr. Sharma Ji, 
            is a renowned institution located in the heart of Prayagraj, Uttar Pradesh. For over 
            three decades, we have been a trusted name in providing high-quality training in 
            shorthand and typing skills, empowering thousands of students to build successful 
            careers in government and private sectors.
          </p>
          <p>
            Our institute stands as a pillar of excellence and dedication in the field of 
            professional skill development. We blend traditional teaching methods with modern 
            tools to ensure that every student gains practical, job-ready expertise. With a 
            strong emphasis on speed, accuracy, and efficiency, our courses are designed to 
            meet the growing demand for proficient stenographers and typists across India.
          </p>
        </div>

        <div className="about-section">
          <h2>Our Mission</h2>
          <p>
            At New Pitman's Institute India, our mission is to empower individuals with 
            professional shorthand and typing skills that open doors to rewarding career 
            opportunities. We are committed to maintaining the highest standards of education 
            while making our courses accessible to students from all backgrounds.
          </p>
        </div>

        <div className="about-grid">
          <div className="about-card">
            <div className="about-card-icon">🎓</div>
            <h3>Expert Faculty</h3>
            <p>
              Learn from experienced professionals with decades of teaching and industry experience.
            </p>
          </div>
          <div className="about-card">
            <div className="about-card-icon">🏆</div>
            <h3>Proven Track Record</h3>
            <p>
              Thousands of our alumni have secured positions in prestigious government and private organizations.
            </p>
          </div>
          <div className="about-card">
            <div className="about-card-icon">📚</div>
            <h3>Comprehensive Curriculum</h3>
            <p>
              Our courses cover all aspects of modern stenography and typing requirements.
            </p>
          </div>
          <div className="about-card">
            <div className="about-card-icon">🔄</div>
            <h3>Modern Approach</h3>
            <p>
              We combine traditional Pitman's methods with contemporary digital tools.
            </p>
          </div>
        </div>

        <div className="about-section">
          <h2>Our Values</h2>
          <div className="values-container">
            <div className="value-item">
              <h3>Excellence</h3>
              <p>We strive for excellence in everything we do, from teaching methods to student support.</p>
            </div>
            <div className="value-item">
              <h3>Integrity</h3>
              <p>We maintain the highest ethical standards in our operations and relationships.</p>
            </div>
            <div className="value-item">
              <h3>Innovation</h3>
              <p>We continuously evolve our teaching methods to incorporate the latest industry requirements.</p>
            </div>
            <div className="value-item">
              <h3>Student Success</h3>
              <p>The success of our students is our ultimate measure of achievement.</p>
            </div>
          </div>
        </div>

        <div className="about-section">
          <h2>Leadership</h2>
          <div className="leadership-container">
            <div className="leader-profile">
              <img src={ayush} className="leader-image-placeholder" alt="ayush" />
              <h3>Ayush Sharma</h3>
              <p className="leader-title">Founder & Director</p>
              <p>
              Ballb llm from cyber security AIBE, diploma in English language and literature from axis university Kanpur diploma in office management and secretarial practice 
              ( specialisation in shorthand ) from Ewing Christian collage prayagraj
              </p>
            </div>
            {/* You can add more leadership profiles as needed */}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta">
        <h2>Join Our Institute Today</h2>
        <p>Take the first step towards a rewarding career in stenography</p>
        <div className="cta-buttons">
          <Link to="/courses" className="btn btn-primary">
            Explore Our Courses
          </Link>
          <Link to="/contact" className="btn btn-secondary">
            Contact Us
          </Link>
        </div>
      </section>
    </div>
    <Footer />
    </>
  );
};

export default About;